import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../../actions/modal';
import { editCurrentSupply } from '../../../actions/supplies';
import { fetchGetCounteragents } from '../../../actions/settings';
import { formatPhone } from '../../../helpers/phoneFormatter';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  padding-left: 0;
  padding-right: 0;
  > div,
  > p {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
`;

const SupplierBlock = (props) => {
  const dispatch = useDispatch();
  const currentSupply = useSelector((state) => state.supplies.currentSupply);
  const supplier = currentSupply.supplier;

  const { t } = useAutoTranslation();

  let person = null;
  if (supplier && supplier.organization && supplier.organization.persons) {
    person =
      supplier.organization.persons.find(
        (person) => person.personType === 'DELIVERY_RESPONSIBLE',
      ) ||
      supplier.organization.persons.find((person) => person.personType === 'CHIEF') ||
      supplier.organization.persons[0];
  }

  const handleChange = (supplier) => {
    dispatch(
      editCurrentSupply({
        ...currentSupply,
        supplier,
      }),
    );
  };

  const handleEditCountreagent = (countragent) => {
    //При открытии попапа редактирования контрагента попап выбора контрагента из которого вызвано данное событие, автоматически закроется. Так устроена существующая система попапов.
    dispatch(
      showModal('EditCountragent', {
        countragent,
        handleUpdateCountragent: (id) => {
          dispatch(fetchGetCounteragents({ id })).then(({ counteragents }) =>
            handleChange(counteragents[0]),
          );
        },
      }),
    );
  };

  const handleOpenModal = () => {
    dispatch(
      showModal('SelectContragent', {
        supplier: currentSupply.supplier,
        handleChange,
        handleEditCountreagent,
      }),
    );
  };

  const isSupplyClosed =
    currentSupply.status === 'COMPLETED' ||
    currentSupply.status === 'COMPLETED_WITH_DIFFERENCE' ||
    currentSupply.status === 'CANCELED';

  return (
    <Wrapper className="card-box">
      <div style={{ display: 'flex' }}>
        <h4 className="header-title">{t('Поставщик')}</h4>
        {!isSupplyClosed ? (
          <div className="change-link" style={{ marginLeft: 'auto' }} onClick={handleOpenModal}>
            {t('Изменить')}
          </div>
        ) : null}
      </div>
      <p className="font-13 font-weight-bold mb-1">{supplier ? t(supplier.name) : null}</p>
      {supplier && supplier.organization && supplier.organization.inn ? (
        <p>ИНН: {supplier.organization.inn}</p>
      ) : null}
      <div className="border-top">
        <h4 className="block-subtitle">{t('Контакты')}</h4>
        <p className="mb-1">{person ? person.fullName : null}</p>
        <p className="mb-1">{person ? formatPhone(person.phone) : null}</p>
        <p className="mb-0">{person ? person.email : null}</p>
      </div>
    </Wrapper>
  );
};

export default SupplierBlock;
